// Client for the passwordless login overlay (mirrors website/Api/AuthController.cs).

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

// Reads a { error } body from a failed response so the message can be shown in the overlay.
async function throwOnError(response: Response): Promise<void> {
  if (response.ok) {
    return;
  }
  let message = `${response.status} ${response.statusText}`;
  try {
    const body = await response.json();
    if (body?.error) {
      message = body.error;
    }
  } catch {
    /* keep the status-based message */
  }
  throw new Error(message);
}

async function requestCode(email: string): Promise<void> {
  const response = await fetch('/api/Auth/request-code', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ Email: email }),
  });
  await throwOnError(response);
}

async function verifyCode(email: string, code: string): Promise<void> {
  const response = await fetch('/api/Auth/verify-code', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ Email: email, Code: code }),
  });
  await throwOnError(response);
}

async function passwordLogin(email: string, password: string): Promise<void> {
  const response = await fetch('/api/Auth/password', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ Email: email, Password: password }),
  });
  await throwOnError(response);
}

// URL that kicks off Google OAuth, returning to the current page afterwards.
function googleUrl(): string {
  const returnUrl = window.location.pathname + window.location.search;
  return '/api/Auth/google?returnUrl=' + encodeURIComponent(returnUrl);
}

export default {
  requestCode,
  verifyCode,
  passwordLogin,
  googleUrl,
};
